$(document).ready(function() {
  const locale = $('#locale-picker').val()
  $('#locale-picker').on('change', function() {
    const oldLocale = locale
    const newLocale = $(this).val()
    const url = new URL(window.location.href)
    window.location.href = url.toString().replace(`/${oldLocale}/`, `/${newLocale}/`)
  })
})
